// @ts-nocheck

// This file was generated by [tauri-specta](https://github.com/oscartbeaumont/tauri-specta). Do not edit this file manually.

/** user-defined commands **/

export const commands = {
  async getEventNotification(): Promise<boolean> {
    return await TAURI_INVOKE('plugin:notification|get_event_notification');
  },
  async setEventNotification(enabled: boolean): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|set_event_notification', {
      enabled,
    });
  },
  async getDetectNotification(): Promise<boolean> {
    return await TAURI_INVOKE('plugin:notification|get_detect_notification');
  },
  async setDetectNotification(enabled: boolean): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|set_detect_notification', {
      enabled,
    });
  },
  async openNotificationSettings(): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|open_notification_settings');
  },
  async requestNotificationPermission(): Promise<null> {
    return await TAURI_INVOKE(
      'plugin:notification|request_notification_permission'
    );
  },
  async checkNotificationPermission(): Promise<NotificationPermission> {
    return await TAURI_INVOKE(
      'plugin:notification|check_notification_permission'
    );
  },
  async startDetectNotification(): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|start_detect_notification');
  },
  async stopDetectNotification(): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|stop_detect_notification');
  },
  async setupAutoDetectPermissions(): Promise<null> {
    return await TAURI_INVOKE(
      'plugin:notification|setup_auto_detect_permissions'
    );
  },
  async startEventNotification(): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|start_event_notification');
  },
  async stopEventNotification(): Promise<null> {
    return await TAURI_INVOKE('plugin:notification|stop_event_notification');
  },
  async showCustomNotification(
    notification: CustomNotificationData
  ): Promise<ShowNotificationResult> {
    return await TAURI_INVOKE('plugin:notification|show_custom_notification', {
      notification,
    });
  },
  async showNotifyRustNotification(
    notification: NotifyRustNotificationData
  ): Promise<null> {
    return await TAURI_INVOKE(
      'plugin:notification|show_notify_rust_notification',
      { notification }
    );
  },
  async setEventNotificationLeadMinutes(minutes: number[]): Promise<null> {
    return await TAURI_INVOKE(
      'plugin:notification|set_event_notification_lead_minutes',
      { minutes }
    );
  },
  async getEventNotificationLeadMinutes(): Promise<number[]> {
    return await TAURI_INVOKE(
      'plugin:notification|get_event_notification_lead_minutes'
    );
  },
};

/** user-defined events **/

/** user-defined constants **/

/** user-defined types **/

export type CustomNotificationData = {
  title: string;
  message: string;
  url?: string | null;
  timeout?: number | null;
  actionLabel?: string | null;
  subtitle?: string | null;
  sound?: boolean | null;
  threadId?: string | null;
  interruptionLevel?: string | null;
  relevanceScore?: number | null;
  actionOnBodyClick?: boolean | null;
};
export type NotificationAction = { identifier: string; title: string };
export type ShowNotificationResult = { permission: string };
export type NotificationPermission =
  | 'Granted'
  | 'NotGrantedAndShouldRequest'
  | 'NotGrantedAndShouldAskManual';
export type NotifyRustNotificationData = {
  title: string;
  message: string;
  subtitle: string | null;
  icon: string | null;
  timeout: number | null;
  app_name: string | null;
  urgency: string | null;
  category: string | null;
  actions: NotificationAction[] | null;
  url: string | null;
  resident: boolean | null;
  sound_name: string | null;
  image_path: string | null;
  custom_hints: Partial<{ [key in string]: string }> | null;
};

/** tauri-specta globals **/

import { invoke as TAURI_INVOKE } from '@tauri-apps/api/core';
import * as TAURI_API_EVENT from '@tauri-apps/api/event';
import { type WebviewWindow as __WebviewWindow__ } from '@tauri-apps/api/webviewWindow';

type __EventObj__<T> = {
  listen: (
    cb: TAURI_API_EVENT.EventCallback<T>
  ) => ReturnType<typeof TAURI_API_EVENT.listen<T>>;
  once: (
    cb: TAURI_API_EVENT.EventCallback<T>
  ) => ReturnType<typeof TAURI_API_EVENT.once<T>>;
  emit: null extends T
    ? (payload?: T) => ReturnType<typeof TAURI_API_EVENT.emit>
    : (payload: T) => ReturnType<typeof TAURI_API_EVENT.emit>;
};

export type Result<T, E> =
  | { status: 'ok'; data: T }
  | { status: 'error'; error: E };

function __makeEvents__<T extends Record<string, any>>(
  mappings: Record<keyof T, string>
) {
  return new Proxy(
    {} as unknown as {
      [K in keyof T]: __EventObj__<T[K]> & {
        (handle: __WebviewWindow__): __EventObj__<T[K]>;
      };
    },
    {
      get: (_, event) => {
        const name = mappings[event as keyof T];

        return new Proxy((() => {}) as any, {
          apply: (_, __, [window]: [__WebviewWindow__]) => ({
            listen: (arg: any) => window.listen(name, arg),
            once: (arg: any) => window.once(name, arg),
            emit: (arg: any) => window.emit(name, arg),
          }),
          get: (_, command: keyof __EventObj__<any>) => {
            switch (command) {
              case 'listen':
                return (arg: any) => TAURI_API_EVENT.listen(name, arg);
              case 'once':
                return (arg: any) => TAURI_API_EVENT.once(name, arg);
              case 'emit':
                return (arg: any) => TAURI_API_EVENT.emit(name, arg);
            }
          },
        });
      },
    }
  );
}
